import { db, storage } from '../../firebase';

export const setBusiness = (business) => ({
  type: 'SET_BUSINESS',
  business
});

//TODO: implement error handling for logo errors
export const startSetBusiness = () => {
  let businessState;

  return (dispatch) => {
    db.getBusiness()
    .then((business) => {
      businessState = business;
      return storage.getCompanyLogo();
    })
    .then((logo) => {
      logo.getDownloadURL().then(function(url) {
        businessState.logoURL = url;
      })
      dispatch(setBusiness(businessState));
    })
    .catch((error) => {
      console.log("startSetBusiness ERROR:", error);
    });
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/business.js